import {createSelector} from 'reselect';

import {getAnalyticsPanel} from '../analyticsPanelSelectors';

export const getAnalyticsDetails = createSelector(getAnalyticsPanel, ({details}) => details);

export const getAnalyticsDetailsSelectedMetricWithOptions = createSelector(
  getAnalyticsDetails,
  ({selectedMetric, options}) => ({selectedMetric, options}),
);

export const getAnalyticsDetailsCustomLabel = createSelector(
  getAnalyticsDetails,
  ({customLabel}) => customLabel,
);

export const getAnalyticsDetailsConversations = createSelector(
  getAnalyticsDetails,
  ({conversations}) => conversations,
);

export const getIsSidePanelOpen = createSelector(getAnalyticsDetails, ({isSidePanelOpen}) => isSidePanelOpen);

export const getIsConversationDetailsSidePanelOpen = createSelector(
  getAnalyticsDetails,
  ({isConversationDetailsSidePanelOpen}) => isConversationDetailsSidePanelOpen,
);

export const getSelectedConversation = createSelector(
  getAnalyticsDetails,
  ({selectedConversation}) => selectedConversation,
);

export const getAnalyticsDetailsIsLoading = createSelector(getAnalyticsDetails, ({isLoading}) => isLoading);

export const getAnalyticsDetailsError = createSelector(getAnalyticsDetails, ({error}) => error);

export const getAnalyticsDetailsConversationsPageNumber = createSelector(
  getAnalyticsDetails,
  ({conversationsPageNumber}) => conversationsPageNumber,
);
